const style = {
	fillRule: 'evenodd',
};

const svgContainer = {
	display: 'flex',
	justifyContent: 'center',
};
export const Email = () => {
	return (
		<div className="input-icon icon-top" style={svgContainer}>
			<svg style={style} xmlns='http://www.w3.org/2000/svg' width='22.344' height='16.781' viewBox='0 0 22.344 16.781'>
				<path
					id='Capa_41'
					data-name='Capa 41'
					class='cls-1'
					d='M603.411,421.882v-11.7l-5.84,5.771Zm-0.981,1.074-5.863-5.864-0.958.948a2.956,2.956,0,0,1-4.112,0l-0.958-.948-5.865,5.864H602.43Zm0.047-14.158H584.628l7.476,7.471a1.56,1.56,0,0,0,2.9,0Zm-12.944,7.15-5.84-5.771v11.7Zm15.183,7.019a1.516,1.516,0,0,1-.305,1.089,1.4,1.4,0,0,1-1.009.3H583.7a1.318,1.318,0,0,1-.891-0.3,1.37,1.37,0,0,1-.422-1.089V408.826a1.178,1.178,0,0,1,.41-0.9,1.307,1.307,0,0,1,.9-0.378h19.7a1.282,1.282,0,0,1,.986.354,1.3,1.3,0,0,1,.328.92v14.141Z'
					transform='translate(-582.375 -407.563)'
				/>
			</svg>
		</div>
	);
};
export const Password = () => {
	return (
		<div className="input-icon icon-bottom" style={svgContainer}>
			<svg style={style} xmlns='http://www.w3.org/2000/svg' width='9.844' height='17.313' viewBox='0 0 9.844 17.313'>
				<path
					id='Capa_36'
					data-name='Capa 36'
					class='cls-1'
					d='M593.55,466.444a2.823,2.823,0,0,1,2.843,2.794,2.752,2.752,0,0,1-1.113,2.2,1.042,1.042,0,0,0-.393,1.012l1.3,7.169h-5.275l1.3-7.169a1.036,1.036,0,0,0-.392-1.011,2.755,2.755,0,0,1-1.112-2.2,2.821,2.821,0,0,1,2.842-2.794m-4.906,14.029a1.041,1.041,0,0,0,1.022,1.226h7.767a1.043,1.043,0,0,0,1.024-1.226l-1.417-7.813a4.8,4.8,0,0,0,1.434-3.422,4.924,4.924,0,0,0-9.847,0,4.8,4.8,0,0,0,1.434,3.422Z'
					transform='translate(-588.625 -464.375)'
				/>
			</svg>
		</div>
	);
};
export const Reload = ()=>{
	return (
		<div style={svgContainer}>
			<svg style={style} fill="currentColor" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" width="25px" height="25px"><path d="M 25 5 C 14.351563 5 5.632813 13.378906 5.054688 23.890625 C 5.007813 24.609375 5.347656 25.296875 5.949219 25.695313 C 6.550781 26.089844 7.320313 26.132813 7.960938 25.804688 C 8.601563 25.476563 9.019531 24.828125 9.046875 24.109375 C 9.511719 15.675781 16.441406 9 25 9 C 29.585938 9 33.699219 10.925781 36.609375 14 L 34 14 C 33.277344 13.988281 32.609375 14.367188 32.246094 14.992188 C 31.878906 15.613281 31.878906 16.386719 32.246094 17.007813 C 32.609375 17.632813 33.277344 18.011719 34 18 L 40.261719 18 C 40.488281 18.039063 40.71875 18.039063 40.949219 18 L 44 18 L 44 8 C 44.007813 7.460938 43.796875 6.941406 43.414063 6.558594 C 43.03125 6.175781 42.511719 5.964844 41.96875 5.972656 C 40.867188 5.988281 39.984375 6.894531 40 8 L 40 11.777344 C 36.332031 7.621094 30.964844 5 25 5 Z M 43.03125 23.972656 C 41.925781 23.925781 40.996094 24.785156 40.953125 25.890625 C 40.488281 34.324219 33.558594 41 25 41 C 20.414063 41 16.304688 39.074219 13.390625 36 L 16 36 C 16.722656 36.011719 17.390625 35.632813 17.753906 35.007813 C 18.121094 34.386719 18.121094 33.613281 17.753906 32.992188 C 17.390625 32.367188 16.722656 31.988281 16 32 L 9.71875 32 C 9.507813 31.96875 9.296875 31.96875 9.085938 32 L 6 32 L 6 42 C 5.988281 42.722656 6.367188 43.390625 6.992188 43.753906 C 7.613281 44.121094 8.386719 44.121094 9.007813 43.753906 C 9.632813 43.390625 10.011719 42.722656 10 42 L 10 38.222656 C 13.667969 42.378906 19.035156 45 25 45 C 35.648438 45 44.367188 36.621094 44.945313 26.109375 C 44.984375 25.570313 44.800781 25.039063 44.441406 24.636719 C 44.078125 24.234375 43.570313 23.996094 43.03125 23.972656 Z"/>
			</svg>
		</div>
	)
}